import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-view-chip',
  templateUrl: './participant-view-chip.component.html',
  styleUrls: ['./participant-view-chip.component.css']
})
export class ParticipantViewChipComponent implements OnInit {
  taskUserId: any = [];

  constructor() { }

  @Input() participantName : any;
  @Input() participantJsonData : any;
  @Input() flagData : any;

  ngOnInit(): void {
    
    

    this.participantJsonData.agendaList.forEach((element:any) => {

      

      element.minutesList.forEach((data:any) => {
        
        if(data.actionItemOwner != undefined){
          data.actionItemOwner.forEach((el:any) => {
            
            this.taskUserId.push(el.fkSecUserOwner)
           
          
          });
        }
      });
    });
  }

  shortRoleName(roleCode: any) {

    return roleCode.slice(0, 1);
  }

}
